// import React, { useEffect, useState } from "react";
// import axios from "../api/axiosAuth";
// import "../style/fotoPerfilEstudiante.css";

// const FotoPerfilEstudiante = () => {
//   const [filtro, setFiltro] = useState("");
//   const [estudiantes, setEstudiantes] = useState([]);
//   const [selected, setSelected] = useState(null);

//   const [file, setFile] = useState(null);
//   const [preview, setPreview] = useState("");

//   const [loading, setLoading] = useState(false);
//   const [msg, setMsg] = useState("");

//   /* ======================================
//       🔍 BUSCAR ESTUDIANTES
//   ====================================== */
//   const buscar = async () => {
//     if (!filtro.trim()) return;

//     try {
//       setLoading(true);

//       const res = await axios.get(
//         `/foto-perfil-estudiante/buscar?filtro=${filtro}`
//       );

//       setEstudiantes(res.data || []);
//     } catch (err) {
//       console.error("❌ buscar:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const delay = setTimeout(() => {
//       if (filtro) buscar();
//     }, 500);

//     return () => clearTimeout(delay);
//   }, [filtro]);

//   /* ======================================
//       📸 PREVIEW DE IMAGEN
//   ====================================== */
//   const handleFile = (e) => {
//     const img = e.target.files[0];
//     setFile(img);

//     if (img) {
//       setPreview(URL.createObjectURL(img));
//     }
//   };

//   /* ======================================
//       💾 SUBIR FOTO (CLOUDINARY)
//   ====================================== */
//   const actualizarFoto = async () => {
//     if (!selected || !file) return;

//     try {
//       setLoading(true);
//       setMsg("");

//       const formData = new FormData();
//       formData.append("foto", file);
//       formData.append("matricula_id", selected.matricula_id);

//       const res = await axios.post(
//         "/foto-perfil-estudiante/actualizar-foto",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       setMsg("✅ Foto actualizada correctamente");

//       const nuevaUrl = res.data.foto_estudiante;

//       // actualizar UI
//       setSelected({ ...selected, foto_estudiante: nuevaUrl });

//       setEstudiantes((prev) =>
//         prev.map((e) =>
//           e.matricula_id === selected.matricula_id
//             ? { ...e, foto_estudiante: nuevaUrl }
//             : e
//         )
//       );

//       setFile(null);
//       setPreview("");
//     } catch (err) {
//       console.error("❌ actualizarFoto:", err);
//       setMsg("❌ Error al actualizar foto");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="foto-container">
//       <h2>📸 Foto Perfil Estudiante</h2>

//       {/* 🔎 BUSCADOR */}
//       <div className="search-box">
//         <input
//           type="text"
//           placeholder="Buscar estudiante..."
//           value={filtro}
//           onChange={(e) => setFiltro(e.target.value)}
//         />
//         <button onClick={buscar}>Buscar</button>
//       </div>

//       {/* LISTA */}
//       <div className="resultados">
//         {loading && <p>⏳ Cargando...</p>}

//         {estudiantes.map((e) => (
//           <div
//             key={e.matricula_id}
//             className={`card ${
//               selected?.matricula_id === e.matricula_id ? "active" : ""
//             }`}
//             onClick={() => setSelected(e)}
//           >
//             <img
//               src={
//                 e.foto_estudiante ||
//                 "https://cdn-icons-png.flaticon.com/512/149/149071.png"
//               }
//               alt="foto"
//             />

//             <div>
//               <strong>
//                 {e.nombres_estudiante} {e.apellidos_estudiante}
//               </strong>

//               <p>
//                 📘 {e.grado} - {e.grupo}
//               </p>

//               <small>🆔 {e.documento_estudiante}</small>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* PANEL EDITAR */}
//       {selected && (
//         <div className="editor">
//           <h3>📷 Actualizar Foto</h3>

//           <div className="preview">
//             <img
//               src={
//                 preview ||
//                 selected.foto_estudiante ||
//                 "https://cdn-icons-png.flaticon.com/512/149/149071.png"
//               }
//               alt="preview"
//             />
//           </div>

//           <input type="file" accept="image/*" onChange={handleFile} />

//           <button onClick={actualizarFoto} disabled={loading}>
//             💾 Subir Foto
//           </button>

//           {msg && <p className="msg">{msg}</p>}
//         </div>
//       )}
//     </div>
//   );
// };

// export default FotoPerfilEstudiante;


//

import React, { useEffect, useState } from "react";
import axios from "../api/axiosAuth";
import "../style/fotoPerfilEstudiante.css";

const FotoPerfilEstudiante = () => {
  const [filtro, setFiltro] = useState("");
  const [estudiantes, setEstudiantes] = useState([]);
  const [selected, setSelected] = useState(null);

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const buscar = async () => {
    if (!filtro.trim()) return;

    try {
      setLoading(true);

      const res = await axios.get(`/foto-perfil-estudiante/buscar?filtro=${filtro}`);
      setEstudiantes(res.data || []);
    } catch (err) {
      console.error("❌ buscar:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      if (filtro) buscar();
    }, 500);

    return () => clearTimeout(delay);
  }, [filtro]);

  const handleFile = (e) => {
    const img = e.target.files[0];
    setFile(img);

    if (img) {
      setPreview(URL.createObjectURL(img));
    }
  };

  const actualizarFoto = async () => {
    if (!selected || !file) return;

    try {
      setLoading(true);
      setMsg("");

      const formData = new FormData();
      formData.append("foto", file);
      formData.append("matricula_id", selected.matricula_id || "");
      formData.append("documento", selected.documento || "");
      formData.append("role", selected.role || "");

      const res = await axios.post(
        "/foto-perfil-estudiante/actualizar-foto",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setMsg("✅ Foto actualizada correctamente");

      const nuevaUrl = res.data.foto_estudiante;

      setSelected({ ...selected, foto: nuevaUrl });

      setEstudiantes((prev) =>
        prev.map((e) =>
          e.documento === selected.documento
            ? { ...e, foto: nuevaUrl }
            : e
        )
      );

      setFile(null);
      setPreview("");
    } catch (err) {
      console.error("❌ actualizarFoto:", err);
      setMsg("❌ Error al actualizar foto");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="foto-container">
      <h2>📸 Gestión Universal de Fotos de Perfil</h2>

      <div className="search-box">
        <input
          type="text"
          placeholder="Buscar estudiante, profesor, rector..."
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
        />
        <button onClick={buscar}>Buscar</button>
      </div>

      <div className="resultados">
        {loading && <p>⏳ Cargando...</p>}

        {estudiantes.map((e, i) => (
          <div
            key={i}
            className={`card ${selected?.documento === e.documento ? "active" : ""}`}
            onClick={() => setSelected(e)}
          >
            <img
              src={e.foto || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
              alt="foto"
            />

            <div>
              <strong>{e.nombres} {e.apellidos}</strong>

              <p>👤 {e.role}</p>

              {e.grado && (
                <p>📘 {e.grado} - {e.grupo}</p>
              )}

              <small>🆔 {e.documento}</small>
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <div className="editor">
          <h3>📷 Actualizar Foto</h3>

          <div className="preview">
            <img
              src={
                preview ||
                selected.foto ||
                "https://cdn-icons-png.flaticon.com/512/149/149071.png"
              }
              alt="preview"
            />
          </div>

          <input type="file" accept="image/*" onChange={handleFile} />

          <button onClick={actualizarFoto} disabled={loading}>
            💾 Subir Foto
          </button>

          {msg && <p className="msg">{msg}</p>}
        </div>
      )}
    </div>
  );
};

export default FotoPerfilEstudiante;
